const STARS = [
  { top: "8%", left: "10%", size: 20, delay: "0s", char: "⭐" },
  { top: "14%", left: "82%", size: 16, delay: "0.6s", char: "✨" },
  { top: "30%", left: "5%", size: 14, delay: "1.2s", char: "🌟" },
  { top: "42%", left: "90%", size: 18, delay: "0.3s", char: "⭐" },
  { top: "60%", left: "8%", size: 16, delay: "0.9s", char: "✨" },
  { top: "72%", left: "86%", size: 20, delay: "1.5s", char: "🌟" },
  { top: "88%", left: "14%", size: 14, delay: "0.4s", char: "💫" },
  { top: "20%", left: "48%", size: 12, delay: "1.1s", char: "✨" },
];

export default function FloatingStars() {
  return (
    <div className="pointer-events-none absolute inset-0 z-0" aria-hidden="true">
      {STARS.map((s, i) => (
        <span
          key={i}
          className="absolute joy-twinkle"
          style={{ top: s.top, left: s.left, fontSize: s.size, animationDelay: s.delay }}
        >
          {s.char}
        </span>
      ))}
    </div>
  );
}
